// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';

export const LanguageSelect = (el) => {
  const ui = {
    el,
    body: select('body', document),
    select: select('.select--language', el),
    submit: select('button[type="submit"]', el),
  };

  const handleChange = () => {
    const actionURL = ui.select.value;
    window.parent.location = actionURL;
  };

  const addEvents = () => {
    ui.el.addEventListener('change', () => {
      handleChange();
    });
  }

  const init = () => {
    // The select navigates on change, so the no-JS submit button is redundant;
    // hidden keeps its invisible 1px focus stop out of the tab order
    if (ui.submit) ui.submit.hidden = true;
    addEvents();
  };

  init();
};

export default LanguageSelect;
